import styled from 'styled-components';
export const Styles = styled.div`
  ${''
/* These styles are required for a horizontaly scrollable table overflow */
}

  overflow: auto;
  .table {
    border-spacing: 0;
    display: inline-block;
    margin-bottom: 0px !important;

    .table-buttons {
      display: none;
    }

    .tr:hover > .table-buttons {
      display: inline-block;
      position: absolute;
      right: 125px;
      margin-top: 2px;
      background-color: #f5f5f5 !important;
    }

    .tbody {
      .tr {
        background: #ffffff !important;
        cursor: pointer;
      }
      .tr:hover {
        background-color: #f5f5f5 !important;
      }
    }
    .sortingIconSpan {
      color: black;
      font-size: 19px;
      margin-left: 10px;

      float: right;
      img {
        width: 14px;
      }
    }

    .thead {
      ${''}
    }

    .ellipsis {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .tr {
      background: #ffffff;
      border-bottom: 1px solid #d8d7d7;
      cursor: pointer;
      height: 32px;
    }

    .th,
    .td {
      margin: 0;
      padding: 4px;
      font-family: 'OpenSans-Regular';
      font-size: 14px;
      color: #525252;
      line-height: 18px;
      position: relative;
      opacity: 87%;
      :last-child {
        border-right: 0;
      }

      .resizer {
        display: inline-block;
        background: #a0a0a0;
        right: 0;
        width: 2px;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 1;
        touch-action: none;
        transform: translateX(50%);
        &.isResizing {
          background: gray;
        }
      }
    }

    .td {
      color: #525252;
      line-height: 18px;
    }
    .th {
      text-overflow: ellipsis;
      color: rgb(22, 22, 22);
      line-height: 15px;
      background: #eae9e9 !important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .headerName {
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
`;